let FILE = require('./map01.svg');
const Calc   = require("../utillity/calculate");
const _t = this;

/*
	SVG要素を追加する
*/
module.exports.Init = function(){
	let $Block = $('[data-section_bg-intro]');
	if( $Block === undefined || $Block.find('svg').length >= 2 ) return;

	$Block.prepend( FILE );

	let $g = $Block.find('svg g');

	// style
	$g.css({
		'fill-opacity': 0.3,
	});

	// ポジション設定
	let wh = $(window).height();
	let ww = $(window).width();
	let sh = $Block.find('svg').height();
	let sw = $Block.find('svg').width();


	if( ww === sw && wh - sh > 0) {
		let d = wh - sh;
		$Block.find('svg').css({
			top: d / 2,
		});
	}

};

module.exports.Animate = function() {
	let $Block = $('[data-section_bg-intro]');
	if( $Block === undefined ) return;
	if( $Block.hasClass('is_setuped') ) return;

	if( !$Block.find('svg').length ) _t.Init();

	$Block.addClass('is_setuped');

	let $g = $Block.find('svg g');

	let tl = new TimelineMax({
		repeat: -1,
		repeatDelay: 1,
	});

	tl
		.clear()
		.set($g, {
			'fill-opacity': 0.3,
		}).staggerTo($g, Calc.ToSecond( 3 ), {
			'fill-opacity': 1,
		}, Calc.ToSecond( 5 ))
		.staggerTo($g, Calc.ToSecond( 3 ), {
			'fill-opacity': 0.3,
			delay: 4
		}, Calc.ToSecond( 5 ));
}


// WEBPACK FOOTER //
// ./html/_src/js_wb/animation/map.js